export default __webpack_public_path__ + "static/media/Sonu.5fce6263.png";